import { IFetchResponse } from 'lib/requests/fetch';

export class ApiResponseError extends Error {
  public name = 'ApiResponseError';
}

/**
 * Throws an error if any of the responses have errored.
 *
 * @param responses - The responses should be passed in order of importance. The
 * first errored response will dictate the error message that gets thrown.
 */
export const throwIfAnyResponseHasErrored = (
  responses: IFetchResponse<unknown>[]
): void => {
  for (const response of responses) {
    if (response.error) {
      throw new ApiResponseError(response.message);
    }
  }
};
